<template>
  <div class="download">
    <banner img="../assets/img/appDown.jpg" title="进入小程序" />
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
</style>